import { Menu as AntdMenu, Badge } from 'antd';
import { useAppSelector } from 'app/store';
import { viewerModel } from 'entities/viewer';
import { Link, useLocation } from 'react-router-dom';
import { usePath } from 'shared/hooks';
import { useIndicatorsQuery } from 'app/services/edpApiV1/viewer';
import { uiModel } from 'entities/ui';
import { ONE_MINUTE } from 'shared/constants';
import { getColors } from 'shared/helpers/utils';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import { IndicatorKeys, MenuItem, MenuKeyLink } from '../types';
import { getMenuKeys } from '../helpers';
import { menuItems, menuKeysMap } from '../constants';
import Manual from '../manual';
import RenderItem from './RenderItem';

export const Menu = () => {
  const { pathname } = useLocation();
  const mainPath = usePath(1);
  const menuKeys = getMenuKeys(menuKeysMap, pathname as MenuKeyLink);
  const { openKeys } = menuKeys;
  const { Item } = AntdMenu;
  const colors = getColors();

  const { permissions: myPermissions } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const moderatingPerms = useAppSelector(viewerModel.me.selectors.selectModerators);
  const dublicatePerms = useAppSelector(viewerModel.me.selectors.selectDublicate);
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const { isCollapsed } = useAppSelector(uiModel.Layout.selectors.selectLayout);
  const { isPoll } = useAppSelector(uiModel.Indicators.selectors.selectIndicators);
  //пуллинг запроса индикатаров по флагу isPoll
  const { data: notificationsData } = useIndicatorsQuery(
    { allAvailableOrganizations },
    {
      ...(isPoll ? { pollingInterval: ONE_MINUTE } : {}),
    },
  );

  const prepareItemData = (
    key: React.Key,
    icon: React.ReactNode,
    label: React.ReactNode,
    notification?: IndicatorKeys,
  ) => {
    return {
      key,
      icon:
        isCollapsed && notification ? (
          <Badge offset={[-1, 13]} dot color={colors.clrPrimary} count={notificationsData?.sidebar[notification]}>
            {icon}
          </Badge>
        ) : (
          icon
        ),
      title: label,
    };
  };

  const renderMenuItems = (data: MenuItem[]) =>
    data.map(({ icon, key, label, path, permissions, indicator: notification, moderators }) => {
      const title = path ? <Link to={path}>{label}</Link> : label;
      if (permissions?.some(element => myPermissions?.includes(element))) {
        return (
          <Item {...prepareItemData(key, icon, label, notification)}>
            <RenderItem
              title={title}
              key={key}
              notification={notification}
              notificationsData={notificationsData}
              path={path}
            ></RenderItem>
          </Item>
        );
      } else if (!permissions && moderators?.some(elem => dublicatePerms?.[elem])) {
        return (
          <Item {...prepareItemData(key, icon, label, notification)}>
            <RenderItem
              title={title}
              key={key}
              notification={notification}
              notificationsData={notificationsData}
              path={path}
            ></RenderItem>
          </Item>
        );
      } else if (!permissions && moderators?.some(elem => moderatingPerms?.[elem])) {
        return (
          <Item {...prepareItemData(key, icon, label, notification)}>
            <RenderItem
              title={title}
              key={key}
              notification={notification}
              notificationsData={notificationsData}
              path={path}
            ></RenderItem>
          </Item>
        );
      }
      return null;
    });

  return (
    <>
      <AntdMenu
        {...{
          mode: 'inline',
          selectedKeys: [`/${mainPath}`],
          openKeys,
          theme: 'light',
        }}
      >
        {renderMenuItems(menuItems)}
        <Manual />
      </AntdMenu>
    </>
  );
};
